var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-avatar"},[_c('img',{staticClass:"avatar-css",attrs:{"src":_vm.user.avatar,"alt":""}})]),_c('div',{staticClass:"user-nickname"},[_vm._v(" "+_vm._s(_vm.user.nickname)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }